<template>
  <div>
    <main id="PAGES_CONTAINER" tabindex="-1"  class=" privacy-policy-container size-card shadow-container-policy">
      <div id="SITE_PAGES" class="_1gF1C">
        <div id="a6qx8" class="Ry26q">
          <div class="_3CemL" data-testid="page-bg"></div>
          <div class="_3K7uv">
            <div id="Containera6qx8" class="_1KV2M">
              <div data-mesh-id="Containera6qx8inlineContent" data-testid="inline-content" class="">
                <div data-mesh-id="Containera6qx8inlineContent-gridContainer" data-testid="mesh-container-content">
                  <div id="comp-l56rkrdz" class="_2Hij5 _3bcaz" data-testid="richTextElement">
                    <p class="font_8" style="font-size:38px; text-align:justify;">
                    <span style="font-weight:bold;">
                      <span style="font-size:38px;">
                        <span style="color:#216D40;">Política de Privacidade Health ID</span>
                      </span>
                    </span>
                  </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">&nbsp;</p>

                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <b><span style="color:#216D40;">Introdução</span></b>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Esta Política de Privacidade regulamenta o tratamento de dados pessoais de clientes, colaboradores, parceiros, usuários finais dos clientes sob a responsabilidade da Health ID Lab, além de visitantes dos serviços online mantidos pela empresa.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">A presente Política de Privacidade representa o nosso compromisso com a transparência, a integridade e o respeito à privacidade, à proteção e à segurança dos dados pessoais dos usuários e de nossos stakeholders, em particular de nossos colaboradores, parceiros e restantes dos titulares dos dados que estejam sob a nossa guarda.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Por favor leia atentamente esta política antes de usar ou obter quaisquer materiais, informações, produtos ou serviços da empresa. Nos reservamos o direito de alterar, atualizar ou corrigir esta política a qualquer momento. Ao usar nossos serviços, você consente com a nossa Política de Privacidade e Proteção de Dados e com a coleta, uso e compartilhamento de suas informações conforme descrito abaixo.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;"><b>Entidade Responsável pelo tratamento de Dados</b></span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">A entidade responsável pelo tratamento dos dados é Health ID Lab Lab Ltda., inscrita no CNPJ sob o número 34.037.799/0001-02, com sede na Av. Cristóvão Colombo, n° 1757, - 1° andar - Porto Alegre, RS, CEP 90560-003. Você pode contatar o nosso Encarregado de Dados (DPO) Rodrigo Thimmig Ferreira Gomes pelo telefone (51) 3029-8087 ou pelo e-mail <span
                      style="text-decoration:underline;"><a data-auto-recognition="true"
                                                            href="mailto:seguranca@clichealthid.com">seguranca@clichealthid.com</a></span></span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;"><b>Princípios observados
                    </b></span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Toda informação pessoal identificável que você nos fornece será usada somente de acordo com o permitido por lei, incluindo o necessário para oferecer o produto, serviço ou informação solicitada por você.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Seus dados pessoais não serão vendidos ou alugados e o compartilhamento, se houver, se limita a nossos parceiros de negócio conforme requerido na execução de nossos serviços ou conforme exigido por leis e regulamentações, caso em que a Health ID Lab adota todas medidas necessárias para assegurar que os subcontratados satisfazem os requisitos legais aplicáveis e oferecem as garantias adequadas para a proteção dos dados.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Certos clientes e parceiros de negócio da Health ID Lab também poderão compartilhar dados pessoais com nossa empresa para fins necessários ao seu relacionamento direto com aquelas entidades e neste caso reportar-se-á à Política de Privacidade destas entidades específicas.</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">A Health ID Lab também observa as práticas recomendadas de Segurança da Informação e adota medidas técnicas, organizacionais e administrativas para proteger os dados pessoais de acessos não autorizados e de situações acidentais ou ilícitas de destruição, perda, alteração, comunicação ou difusão, bem como para atuar de conformidade com a Lei Geral de Proteção de Dados Pessoais (Lei nº 13.709/18) e demais regulamentos sobre a matéria.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;"><b>Fundamento para o Tratamento de Dados</b></span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">No exercício das atividades empresariais da Health ID Lab, o tratamento de dados pessoais enquadra-se no consentimento dos titulares, na execução e cumprimento de contrato a pedido do titular, no exercício regular de direito em processo judicial e no legítimo interesse da empresa, sendo assegurados aos titulares os direitos previstos na Lei Geral de Proteção de Dados Pessoais (Lei Nº 13.709/18). Que dados pessoais são recolhidos e tratados?</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                      <b>A Health ID Lab poderá recolher e tratar, entre outros, os seguintes dados pessoais:</b>
                    </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">a) Visitantes do Site: Endereço IP, porta de conexão, informações fornecidas pelo navegador, cookies necessários para o correto funcionamento do site ou aplicação e ainda, no caso de visitantes autenticados, informações de usuário e senha de acesso;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">b) Recrutamento e seleção de colaboradores: nome, endereço de correio eletrônico e currículo vitae;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">c) Usuários das aplicações web providas pela Health ID Lab: Nome, CPF, e-mail, telefone, senha de acesso, foto de perfil, data de nascimento e outras informações que o titular dos dados optou por nos fornecer;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">d) Titulares cujo controlador do tratamento de dados pessoais seja entidade, empresa ou organização cliente da Health ID Lab: Nome, CPF, RG, data de nascimento, dados de saúde e outras informações presentes nas aplicações providas pela Health ID Lab a seus clientes.</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;"><b>
                      De que forma os seus dados são coletados?
                    </b></span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Os dados pessoais podem ser coletados através dos seguintes meios:</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">a) Website e formulários online;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">b) Chamadas telefônicas;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">c) Correio eletrônico;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">d) Através de aplicações (“apps”) instaladas em dispositivos móveis;</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">e) Quando fornecidos pelos clientes da Health ID Lab.</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">​</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Alguns dados pessoais recolhidos são de preenchimento obrigatório e necessários para a execução e realização de nossas atividades, sendo que, em caso de falta ou insuficiência desses dados, a Health ID Lab se resguarda no direito de não prestar os serviços ou as informações solicitadas. Em cada caso concreto, a Health ID Lab irá informá-lo sobre a natureza obrigatória do fornecimento destes dados pessoais e a finalidade de sua utilização.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                      <b>Por quanto tempo os dados pessoais são armazenados?</b>
                    </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">A Health ID Lab cumpre com as normas legais relativas aos prazos de retenção de dados pessoais, podendo mantê-los conforme requerido por lei ou enquanto for necessário para execução de contrato ou serviço.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                      <b>Direitos dos titulares de dados pessoais</b>
                    </span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;">
                      <span style="color:#216D40;">A Health ID Lab assegura aos titulares o exercício dos direitos de confirmação de tratamento, acesso aos dados, correção de dados, eliminação,
                        revogação do consentimento e demais direitos previstos em lei. Para exercer os seus direitos, entre em contato com a Health ID Lab através do email:
                        <span style="text-decoration:underline;">
                          <a data-auto-recognition="true" href="mailto:seguranca@clichealthid.com">seguranca@clichealthid.com</a></span>, encaminhando-nos, conforme for o caso, pedido para adaptação, alteração ou exclusão de seus dados.</span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">​
                    <b>Utilização de Cookies</b></span>
                    </p>


                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Cookies são pequenos dados enviados por um servidor web para o seu navegador e armazenado no seu computador ou dispositivo pessoal. Para oferecer melhor experiência no uso de nossos serviços web e aplicações, poderemos usar cookies de sessão (que expiram quando você fecha o navegador) e cookies persistentes (que permanecem no seu computador até que você os delete). Este tipo de informação é coletada para tornar o serviço mais útil e oferecer uma experiência mais conveniente e valiosa para você.</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Usamos duas categorias de cookies: Cookies servidos diretamente por nós ao seu computador ou dispositivo para que possamos reconhecê-lo quando você retorna ao nosso site e cookies de terceiros, usados para estatísticas de acesso, segurança e disponibilidade do site.</span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">
                      <b>Alterações na Política</b>
                    </span>
                    </p>

                    <p class="font_8" style="text-align:justify; font-size:16px;"><span style="color:#216D40;">Se fizermos alterações nessa Política de Privacidade, iremos informá-lo da mudança na próxima visita ao site e você também poderá entrar em contato com a Health ID Lab via o e-mail <span
                      style="text-decoration:underline;"><a data-auto-recognition="true"
                                                            href="mailto:seguranca@clichealthid.com">seguranca@clichealthid.com</a></span> para direcionar seus questionamentos em relação à mesma.</span>
                    </p></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </main>
    <div class=" size-card">
      <div class="input-box">
        <div class="checkbox-text">
          <input id="accept_terms" type="checkbox" v-model="accept_terms" value="1"/>
          <p for="accept_terms" style="line-height: 2">
            Declaro estar ciente e aceito os termos da política de privacidade apresentados.
          </p>
        </div>
        <div class="form-error" v-if="errors && errors.accept_terms.length > 0">
          <small class="error">
            {{errors.accept_terms.join()}}
          </small>
        </div>
      </div>
      <button class="button btn-primary" @click="handleSubmit">Salvar e Próximo</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "PrivacyPolicy",
  props: {
    next: Function
  },
  data() {
    return {
      errors: {
        accept_terms: []
      },
      accept_terms: false,
    }
  },
  methods: {
    handleSubmit() {
      if(!this.accept_terms){
        this.errors.accept_terms.push("Que Pena! Mas precisamos dessa concordância para realizar a análise da sua amostra. Quer concordar com o termo de consentimento?");
        return false;
      }else{
        console.log();
        this.$emit('next', this.accept_terms)
      }
    }
  }
}
</script>

<style scoped>
@import "./../FormSteps/form-steps.scss";
@import "./../FormSteps/responsive.css";
.privacy-policy-container {
  max-height: 50vh;
  overflow: auto;
}
.size-card {
  max-width: 100%;
  margin: 0 auto;

}
.shadow-container-policy {
  box-shadow: inset -7px -4px 1px 1px #216d400d;
  border: 1px solid #c3c3c345;
  padding: 16px;
}
.input-box {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/RegisterKitSteps/PrivacyPolicy.vue